import { getMarkdownManager } from './markdownManager';

type NormalizeMarkdownReturn =
  | { ok: true; result: string }
  | { ok: false; error: Error };

// Single markdown engine (ENG-4659): canonicalize by round-tripping through the
// editor's OWN @tiptap/markdown engine — parse markdown → Tiptap JSON → serialize.
// This replaced the marked → @tiptap/html → turndown pipeline. Because the score
// and the diff run BOTH operands through this one engine, the editor's
// deterministic reformatting folds away symmetrically and isn't read as an edit.
// The shared engine (see ./markdownManager) uses the editor's extensions +
// markedOptions, so the canonical form tracks the editor's serialization. (Not
// byte-identical — the editor mounts a few extra extensions like Footnote — and
// the engine is whitespace-faithful; see normalizeMarkdown.spec.ts for the exact,
// intentional baseline behavior.)
//
// Input is expected ALREADY decoded: escaped newlines (`\n` literals from the LLM)
// are decoded at write time (mastra saveLlmOutputWithTemplate /
// markLlmOutputAsCompleted), so the callers here (score + diff, reading stored
// content) pass real newlines.
export const normalizeMarkdown = ({
  markdown,
}: {
  markdown: string;
}): NormalizeMarkdownReturn => {
  try {
    const manager = getMarkdownManager();
    const result = manager.serialize(manager.parse(markdown));

    return {
      ok: true,
      result,
    };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
};
